import { useContext, useEffect, useState } from "react";
import ProgressCircle from "../components/ProgressCircle";
import { GAME_STATE_REVEALING_CARDS } from "../contexts/constants";
import { SocketContext } from "../contexts/SocketContext";
import "./Result.css";
function Result({value, average}) {
  const { message, gameState, counting, parrotImageSrc, parrotWord } = useContext(SocketContext);
  const isReveal = gameState === GAME_STATE_REVEALING_CARDS;

  return (
    <div className="result">
      <img src={parrotImageSrc} className="reaction-image" />
      <ProgressCircle value={value}/>
      {message && !counting && <p>{message}</p>}
      {isReveal && !message && !counting && <p className="typing-text"><span>Thinking...</span></p>}
    </div>
  );
}

Result.defaultProps = {
  value: 0,
  average: 0
};

export default Result;
